// extracted by mini-css-extract-plugin
module.exports = {"RatingListHeading":"styles_RatingListHeading__1Q-_C"};